import Rollbar from 'rollbar';
import { Capacitor } from '@capacitor/core';

export const rollbarConfig = {
  enabled: !!import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN,
  accessToken: import.meta.env.VITE_ROLLBAR_CLIENT_TOKEN,
  environment: import.meta.env.VITE_ENV ?? 'production',
  version: import.meta.env.VITE_GIT_COMMIT_HASH,
  payload: {
    custom: {
      isNativePlatform: Capacitor.isNativePlatform(),
    },
  },
  transform: function(payload) {
    const trace = payload.body.trace;
    const locRegex = /^(https?):\/\/[a-zA-Z0-9._-]+\.(?:pages\.dev|laundry-lockers\.com|localhost)(.*)/;
    if (trace && trace.frames) {
      for (let i = 0; i < trace.frames.length; i++) {
        const filename = trace.frames[i].filename;
        if (filename) {
          const m = filename.match(locRegex);
          trace.frames[i].filename = m[1] + '://dynamichost' + m[2];
        }
      }
    }
  }
};

export const rollbar = new Rollbar(rollbarConfig);
